<svg width="128" height="5" viewBox="0 0 128 5" fill="none" xmlns="http://www.w3.org/2000/svg">
  <rect width="128" height="4" transform="translate(0 0.5)" fill="#FFC917" />
</svg>
